module.exports = __webpack_public_path__ + "static/scale-model-of-lake-harriet-south-beach-in-minneapolis-minnesota-5fe6e6edffe0209211b6c92941d586e0.png";